import { render, staticRenderFns } from "./CriarGrupoDeAnaliseDeCompras.vue?vue&type=template&id=a0a9e0ec"
import script from "./CriarGrupoDeAnaliseDeCompras.vue?vue&type=script&lang=js"
export * from "./CriarGrupoDeAnaliseDeCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports